import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const UploadedPhotoWrapper = styled(Box)`
    background-image: ${({ theme }) =>
        `repeating-linear-gradient(0deg, ${theme.colors.primary_500}, ${theme.colors.primary_500} 11px, transparent 11px, transparent 23px, ${theme.colors.primary_500} 23px), repeating-linear-gradient(90deg, ${theme.colors.primary_500}, ${theme.colors.primary_500} 11px, transparent 11px, transparent 23px, ${theme.colors.primary_500} 23px), repeating-linear-gradient(180deg, ${theme.colors.primary_500}, ${theme.colors.primary_500} 11px, transparent 11px, transparent 23px, ${theme.colors.primary_500} 23px), repeating-linear-gradient(270deg, ${theme.colors.primary_500}, ${theme.colors.primary_500} 11px, transparent 11px, transparent 23px, ${theme.colors.primary_500} 23px)`};
    background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
    border-radius: 10px;
    width: 296px;

    @media ${respondAbove.xl} {
        width: 286px;
    }
`
export const CropperWrapper = styled(Box)`
    position: relative;
    min-height: 353px;

    img {
        width: auto;
        max-width: none;
    }
    & > img {
        width: 100%;
    }

    @media ${respondAbove.xl} {
        min-height: 270px;
    }
`
